import { Helmet } from 'react-helmet';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Debug from '../components/debug/debug';
import LoadingIndicator from '../components/loadingIndicator/loadingIndicator';
import useBodyClass from '../hooks/useBodyClass';
import useContentForBuild from '../hooks/useContentForBuild';
import useDlogLoginFunnel from '../hooks/useDlogLoginFunnel';

export default function Status() {
  const navigate = useNavigate();
  const [isCheckingServerStatus, setIsCheckingServerStatus] = useState(false);
  const [content, loading, error, retry] = useContentForBuild();
  const dlog = useDlogLoginFunnel();
  useBodyClass('bg-status');

  useEffect(() => {
    dlog({
      phase: 'Server_Maintenance',
      action: 'Render',
    });
  }, [dlog]);

  const getServerStatus = () => {
    setIsCheckingServerStatus(true);

    dlog({
      phase: 'Server_Maintenance',
      action: 'Click',
      targets: 'Retry',
    });

    retry();
  };

  // If the reloading content indicates the server is healthy again, go to the loading page to trigger the normal boot flow process
  useEffect(() => {
    if (content && !content.Status) {
      navigate('/loading');
    }
  }, [content, navigate]);

  // Delay when we stop showing the loading indicator so there is enough time for the user to notice the loading indicator from their retry
  useEffect(() => {
    if (!loading && isCheckingServerStatus) {
      const timeout = setTimeout(() => {
        setIsCheckingServerStatus(false);
      }, 3000);
      return () => clearTimeout(timeout);
    }
  }, [loading, isCheckingServerStatus]);

  let currentStatus = '';
  if (isCheckingServerStatus) {
    currentStatus = content?.statusCheckStatus ?? '';
  } else if (error) {
    currentStatus = 'An unexpected error occurred.';
  } else {
    currentStatus = content?.statusMessage ?? '';
  }

  return (
    <>
      <Helmet>
        <title>{content?.statusPageTitle}</title>
        <meta name="description" content="server status" />
      </Helmet>
      <div className="container">
        {loading && (
          <div className="loading-mask">
            <LoadingIndicator />
          </div>
        )}
        <h1>{content?.statusPageTitle}</h1>
        <p className="preline">{currentStatus}</p>
        <button onClick={getServerStatus} disabled={isCheckingServerStatus}>
          {content?.statusCta ?? 'Check Status'}
        </button>
      </div>
      <Debug
        enabled={!!content?.showDeveloperOverlay}
        vars={{
          isCheckingServerStatus,
          loading,
          error,
        }}
      >
        <button
          onClick={() => {
            window.location.reload();
          }}
        >
          Reload
        </button>
      </Debug>
    </>
  );
}
